export type ColumnFilterType =
  | "multiSelect"
  | "singleSelect"
  | "yesNo"
  | "text"
  | "dateRange"
  | "tagsAutocomplete"
  | "customText"
  | "customNumber"
  | "customDate"
  | "customChoice";

export type FilterOption = { label: string; value: string };

export type ColumnFilterConfig = {
  filterKey: string;
  type: ColumnFilterType;
  options?: FilterOption[];
  /** Custom study columns */
  varname?: string;
  questionType?: string;
  questionLabel?: string;
  questionChoices?: { label: string; id: string }[];
};

export type DateRangeValue = { from: string; to: string };

export const STUDY_STATUS_OPTIONS: FilterOption[] = [
  { label: "Included", value: "included" },
  { label: "Excluded", value: "excluded" },
  { label: "Unverified", value: "unverified" },
  { label: "Withdrawn", value: "withdrawn" },
  { label: "Decide Later", value: "decide_later" },
];

export const YES_NO_OPTIONS: FilterOption[] = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export const CUSTOM_COLUMN_ALLOWED_TYPES = [
  "radio",
  "checkbox",
  "dropdown",
  "text",
  "number",
  "date",
  "calculated_field",
  "calculated_field_text",
];
